import { FormattedMessage, FormattedNumber } from "react-intl";
import { PrintInfo } from "common/api/decimal/methods/course.ts";

export default function PrintReturnSummary({
  printInfo: { pendingReturns, totalPenalty, returnDate },
}: {
  printInfo: PrintInfo;
}) {
  const allReturns = pendingReturns.flatMap((course) => course.books!);
  return (
    <FormattedMessage
      defaultMessage="{count, plural, one {You have # print book that needs to be returned to the bookstore by {deadline, date, long} or your account will be charged {price}} other {You have # print books that need to be returned to the bookstore by {deadline, date, long} or your account will be charged {price}}}."
      values={{
        count: allReturns.length,
        deadline: new Date(returnDate),
        price: (
          <FormattedNumber
            value={totalPenalty}
            style="currency"
            currency="USD"
          />
        ),
      }}
    />
  );
}
